
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vip/consult",
      function () {
        return require("private-next-pages/vip/consult/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vip/consult"])
      });
    }
  